import { render, staticRenderFns } from "./PersonalView.vue?vue&type=template&id=0dca3516&scoped=true"
import script from "./PersonalView.vue?vue&type=script&lang=js"
export * from "./PersonalView.vue?vue&type=script&lang=js"
import style0 from "./PersonalView.vue?vue&type=style&index=0&id=0dca3516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca3516",
  null
  
)

export default component.exports